import { render, staticRenderFns } from "./AddShopDialog.vue?vue&type=template&id=62564a65&scoped=true&"
import script from "./AddShopDialog.vue?vue&type=script&lang=ts&"
export * from "./AddShopDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddShopDialog.vue?vue&type=style&index=0&id=62564a65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62564a65",
  null
  
)

export default component.exports